import React from "react";
import { Link } from "react-router-dom";
import Card from "../../ui/Card";

// =============================================================================
// LEADERBOARD CARD
// =============================================================================
// PURPOSE: Inline dashboard preview card that links to full LeaderboardPage.
//
// BEHAVIOR: Hover state with blue highlight and arrow icon.
// =============================================================================

const LeaderboardCard: React.FC = () => (
  <Link to="/admin/leaderboard" className="block">
    <Card className="hover:border-black/[0.2] hover:shadow-md transition-all cursor-pointer group">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-bold text-glass group-hover:text-blue-300 transition-colors">
            Leaderboard
          </h3>
          <p className="text-sm text-glass-secondary mt-1">
            View rankings, prestige points, and sector-specific performance
          </p>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-glass-muted group-hover:text-blue-300 transition-colors"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          />
        </svg>
      </div>
    </Card>
  </Link>
);

export default LeaderboardCard;
